<template>
  <div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'loading',
    computed: {
      ...mapState('destiny/profile', ['characters'])
    },
    watch: {
      characters (newCharacters) {
        if (newCharacters) {
          this.$router.push({
            name: 'manager',
            params: {character: newCharacters[0].key}
          })
        }
      }
    },
    mounted () {
      if (this.characters && this.characters.length) {
        this.$router.push({
          name: 'manager',
          params: {character: this.characters[0].key}
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loading {
    text-align: center;
    border-top: 4px solid rgba(255, 255, 255, 0);
    border-right: 4px solid rgba(255, 255, 255, .2);
    border-bottom: 4px solid rgba(255, 255, 255, .4);
    border-left: 4px solid rgba(255, 255, 255, .8);
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    animation: spin 2s linear infinite;

    display: block;
    margin: 3rem auto;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?66e0422e